<template>
  <div class="tw-inline-block">
    <b-button :id="'popover-info-' + id" variant="link" size="sm">
      <i class="fas fa-info"></i>
    </b-button>

    <b-popover
      :target="'popover-info-' + id"
      placement="top"
      triggers="hover focus"
    >
      <template v-slot:title>
        <slot name="title">Info</slot>
      </template>
      
      <slot></slot>
    </b-popover>
  </div>
</template>

<script>
    // import {
    //     HTTP
    // } from '@/utilities/http-common';
    // import HandleErrors from '@/utilities/handle-errors';

    // import {
    //     mapState, mapGetters, mapActions
    // } from 'vuex';
    
    import * as _ from 'lodash';

    export default {
        mixins: [

        ],
        components: {

        },
        props: {
        },
        data: function () {
            return {
                id: null
            }
        },
        computed: {
            // ...mapState('sample', ['sample'])
        },
        created: function () {
          this.id = _.random(0, 10000);
        },
        mounted: function () {

        },
        methods: {
            get: function () {
                // HTTP.get('/').then((response) => {
                //     let something = response.data;
                // }).catch((error) => {
                //     HandleErrors.HandleErrors(error);
                // });
            },
            find: function () {

            },
            create: function () {

            },
            patch: function () {

            },
            update: function () {

            },
            delete: function () {

            }
        }
    }
</script>